import api from '../api.js';
import * as types from '../types.js';

export default {

	html: `
		<style>
			#stock #company_id			{ width: 10rem;		}
			#stock #id					{ width: 5rem; text-align: right;	}
			#stock #warehouse_id		{ width: 10rem;		}
			#stock #location_id			{ width: 10rem;		}
			#stock #lot_company_id		{ width: 10rem;		}
			#stock #lot_id				{ width: 5rem; text-align: right;	}
			#stock #quantity_available	{ width: 5rem; text-align: right;	}
			#stock #quantity_reserved	{ width: 5rem; text-align: right;	}
			#stock #quantity_unsettled	{ width: 5rem; text-align: right;	}
			#stock #status				{ width: 10rem;		}
		</style>
		<form id="stock" class="form" autocomplete="off">
			<datalist id="companies">
			</datalist>
			<datalist id="warehouses">
			</datalist>
			<datalist id="locations">
			</datalist>
			<fieldset class="stock-product-info" title="Dados do produto e lote (somente leitura)">
				<legend>Produto / Lote</legend>
				<div class="fsb">
					<label>SKU <input id="stock_sku" type="text" disabled></label>
					<label>Produto <input id="stock_product_name" type="text" disabled></label>
					<label>ID Fabricante <input id="stock_manufacturer_id" type="text" disabled></label>
					<label>Fabricante <input id="stock_manufacturer_nick" type="text" disabled></label>
					<label>NCM <input id="stock_ncm" type="text" disabled></label>
					<label>EAN <input id="stock_gtin" type="text" disabled></label>
					<label>Embalagem <input id="stock_packaging_code" type="text" disabled></label>
				</div>
				<div class="fsb">
					<label>Fator Emb. <input id="stock_packaging_factor" type="text" disabled></label>
					<label>QR Emb. <input id="stock_packaging_qr" type="text" disabled></label>
				</div>
				<div class="fsb">
					<label>Lote fabricante <input id="stock_lot_number" type="text" disabled></label>
					<label>Validade <input id="stock_expiration_date" type="text" disabled></label>
					<label>Fabricação <input id="stock_manufacture_date" type="text" disabled></label>
					<label>Programa <input id="stock_program_name" type="text" disabled></label>
					<label>Cód. cliente <input id="stock_codigo_cliente" type="text" disabled></label>
				</div>
				<div class="fsb">
					<label>Data Entrada <input id="stock_input_created_on" type="text" disabled></label>
					<label>Entrada Sial <input id="stock_input_id" type="text" disabled></label>
					<label>Nota Entrada <input id="stock_invoice_number" type="text" disabled></label>
					<label>Fornecedor <input id="stock_supplier_name" type="text" disabled></label>
				</div>
			</fieldset>
			<div class="fsb">
				<label title="Empresa detentora do registro">Empresa
					<input id="company_id" type="text" list="companies" disabled>
				</label>
				<label title="Identificador do estoque">Estoque
					<input id="id" type="text" disabled>
				</label>
				<label title="Status do estoque">Status
					<input id="status" type="text" list="stock_status" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Armazém do estoque">Armazém
					<input id="warehouse_id" type="text" list="warehouses" disabled>
				</label>
				<label title="Posição no armazém">Posição
					<input id="location_id" type="text" list="locations" disabled>
				</label>
				<label title="Identificador do lote">Lote
					<input id="lot_id" type="text" disabled>
				</label>
			</div>
			<div class="fsb">
				<label title="Titular do lote">Titular
					<input id="lot_company_id" type="text" list="companies" disabled>
				</label>
				<label title="Quantidade disponível do estoque">Disponível
					<input id="quantity_available" type="text" disabled>
				</label>
				<label title="Quantidade reservada do estoque">Reservado
					<input id="quantity_reserved" type="text" disabled>
				</label>
				<label title="Quantidade do estoque sob análise">Bloqueado
					<input id="quantity_unsettled" type="text" disabled>
				</label>
			</div>
			<div class="fsb mtm">
				<span>
				</span>
				<span>
					<button class='bn_Escape button'>Fechar</button>
				</span>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#stock',
		init(formset)	// Must not be async as init seq must be preserved
		{
			formset.loadList('#companies', 'companies', { labels: ['nick'] });
			Object.getPrototypeOf(this).init.call(this);
		},
	},
	
	fields: [
		{ properties: { selector: '#stock_sku' }, types: [] },
		{ properties: { selector: '#stock_product_name' }, types: [] },
		{ properties: { selector: '#stock_manufacturer_id' }, types: [] },
		{ properties: { selector: '#stock_manufacturer_nick' }, types: [] },
		{ properties: { selector: '#stock_ncm' }, types: [] },
		{ properties: { selector: '#stock_gtin' }, types: [] },
		{ properties: { selector: '#stock_packaging_code' }, types: [] },
		{ properties: { selector: '#stock_packaging_factor' }, types: [] },
		{ properties: { selector: '#stock_packaging_qr' }, types: [] },
		{ properties: { selector: '#stock_lot_number' }, types: [] },
		{ properties: { selector: '#stock_expiration_date' }, types: [] },
		{ properties: { selector: '#stock_manufacture_date' }, types: [] },
		{ properties: { selector: '#stock_program_name' }, types: [] },
		{ properties: { selector: '#stock_codigo_cliente' }, types: [] },
		{ properties: { selector: '#stock_input_created_on' }, types: [] },
		{ properties: { selector: '#stock_input_id' }, types: [] },
		{ properties: { selector: '#stock_invoice_number' }, types: [] },
		{ properties: { selector: '#stock_supplier_name' }, types: [] },
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#warehouse_id' }, types: [types.pubsub(), types.datalist(), types.observer('company_id'), types.obs_load_options('warehouses')] },
		{ properties: { selector: '#location_id' }, types: [types.pubsub(), types.datalist(), types.observer('warehouse_id'), types.obs_load_options('locations', { labels: ['address'], sep: '-', key: 'company_id' })] },
		{ properties: { selector: '#lot_company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#lot_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#quantity_available' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#quantity_reserved' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#quantity_unsettled' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#status' }, types: [types.opt_stock_status(), types.datalist()] },
	]

};

